// extracted by css-extract-rspack-plugin
export default {"wrapper":"e3M5B","label":"QYk1d","image":"pkJuu","image_animated":"UibAa","imageAnimated":"UibAa","bounceIn":"oDNm6"};